import { Action } from '../actions/fuelLogs';
import getErrorMessage from '../../lib/utils/getErrorMessage';

const defaultState = {
  fuelLogsMap: {},
  fuelLogEntry: undefined,
  isFetching: false,
  error: undefined,
  isDeleting: false,
  isSaving: false,
  isExporting: false,
  fuelLogResponse: undefined,
  years: undefined,
};

export default function fuelLogsReducer(state = defaultState, action) {
  switch (action?.type) {
    case Action.FuelLogs.FetchFuelLogsPending:
      return {
        ...state,
        fuelLogEntry: undefined,
        isFetching: true,
        error: undefined,
      };

    case Action.FuelLogs.FetchFuelLogsCompleted:
      return {
        ...state,
        isFetching: false,
        fuelLogsMap: {
          ...state.fuelLogsMap,
          [action.meta.fuelLogKey]: state.fuelLogsMap[action.meta.fuelLogKey]
            ? [].concat(state.fuelLogsMap[action.meta.fuelLogKey], action.payload.fuelLogs)
            : action.payload.fuelLogs,
        },
      };

    case Action.FuelLogs.FetchFuelLogsFailed:
      return {
        ...state,
        isFetching: false,
        error: 'There was an error fetching fuel logs',
      };

    case Action.FuelLogEntry.AddFuelLogEntryPending:
    case Action.FuelLogEntry.UpdateFuelLogEntryPending:
      return {
        ...state,
        isSaving: true,
        error: undefined,
      };

    case Action.FuelLogEntry.AddFuelLogEntryCompleted:
      return {
        ...state,
        isSaving: false,
        fuelLogsMap: {
          ...state.fuelLogsMap,
          [action.meta.fuelLogKey]: [].concat(
            state.fuelLogsMap[action.meta.fuelLogKey] || [],
            action.payload.fuelLog,
          ),
        },
        fuelLogResponse: action.payload.fuelLogResponse,
      };

    case Action.FuelLogEntry.AddFuelLogEntryFailed:
    case Action.FuelLogEntry.UpdateFuelLogEntryFailed:
      return {
        ...state,
        isSaving: false,
        error: 'There was an error saving fuel log entry',
      };

    case Action.FuelLogEntry.UpdateFuelLogEntryCompleted:
      return {
        ...state,
        isSaving: false,
        fuelLogsMap: {
          ...state.fuelLogsMap,
          [action.meta.fuelLogKey]: state.fuelLogsMap[action.meta.fuelLogKey]
            .map(
              fuelLog => (fuelLog.log.guid === action.payload.fuelLog.log.guid ? action.payload.fuelLog : fuelLog),
            ),
        },
        fuelLogResponse: action.payload.fuelLogResponse,
      };

    case Action.FuelLogEntry.DeleteFuelLogEntryPending:
      return {
        ...state,
        isDeleting: true,
        error: undefined,
      };

    case Action.FuelLogEntry.DeleteFuelLogEntryCompleted:
      return {
        ...state,
        isDeleting: false,
        fuelLogsMap: {
          ...state.fuelLogsMap,
          [action.meta.fuelLogKey]: state.fuelLogsMap[action.meta.fuelLogKey]
            .filter(log => log.log.guid !== action.meta.fuelLogGuid),
        },
        fuelLogEntry: undefined,
      };

    case Action.FuelLogEntry.DeleteFuelLogEntryFailed:
      return {
        ...state,
        isDeleting: false,
        error: 'There was an error removing the fuel log entry',
      };

    case Action.FuelLogEntry.ResetFuelLogResponse:
      return {
        ...state,
        fuelLogResponse: undefined,
      };

    case Action.FuelLogs.ExportFuelLogsPending:
      return {
        ...state,
        isExporting: true,
        error: undefined,
        years: undefined,
      };

    case Action.FuelLogs.ExportFuelLogsCompleted:
      return {
        ...state,
        isExporting: false,
        years: action.payload.years,
      };

    case Action.FuelLogs.ExportFuelLogsFailed:
      return {
        ...state,
        isExporting: false,
        error: getErrorMessage(action.payload, 'There was an error exporting your fuel logs'),
      };

    case Action.FuelLogs.ResetFuelLogsExportResponse:
      return {
        ...state,
        isExporting: false,
        error: undefined,
        years: undefined,
      };

    default:
      return state;
  }
}
